import { CircleHelp } from "lucide-react";

import { IgIconButton, IgTooltip } from "@intelligems/ig-theme";
import { ExpressionNodeQueryType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { openNewTab } from "@src/utils/openNewTab";

import { getHint } from "./utils";

interface ConditionHintProps {
  expressionQuery: ExpressionNodeQueryType;
}

export const ConditionHint = ({ expressionQuery }: ConditionHintProps) => {
  const hint = getHint(expressionQuery.type);
  return (
    hint && (
      <Grid item>
        <IgTooltip title={hint.text}>
          <IgIconButton
            onClick={() => {
              if (hint.link && hint.tracker) {
                openNewTab(hint.link, hint.tracker);
              }
            }}
          >
            <CircleHelp size={18} />
          </IgIconButton>
        </IgTooltip>
      </Grid>
    )
  );
};
